module.exports = __webpack_public_path__ + "img/02_bg.5b9e83aa.png";